export enum FeatureToggle {
  HPP_STRENSIQ = "hpp-strensiq",
  ZEPBOUND_OSA = "zepbound-osa",
  WEGOVY_MASH = "wegovy-mash",
  ASTHMA = "asthma",
  LIVER_TRANSPLANT = "liver-transplant",

  APPEAL_HUB_REFERRAL_FLOW_V2 = "appeal-hub-referral-flow-v2",
  APPEAL_HUB_SEARCH_AND_FILTER_V2 = "appeal-hub-search-and-filter-v2",

  DISABLE_LETTER_ISSUE_EMAILS = "disable-letter-issue-emails",

  AUTH_FLOW_V2 = "auth-flow-v2",
}
